import React from 'react';
import { Grid, Header, Image, Icon, Segment, Divider } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { Button } from 'semantic-ui-react';

import logo from "../../images/logo/logo-full-black.png";
import LoadingComponent from "../common/LoadingComponent";

import Reaptcha from 'reaptcha';

const styles = {
    mainText: {
        color: "#0a0f1f"
    },
    bottomMessageBold: {
        fontSize: "0.9rem",
        marginBottom: "0px",
        fontWeight: "bolder"
    },
    bottomMessage: {
        fontSize: "0.85rem"
    },
    captchaContainer: {
        display: "flex",
        justifyContent: "center"
    }
}

class ResendEmailComponent extends React.Component {

    constructor(props) {
        super(props);

        this.recaptchaInstance = null;
        this.state = {
            iamNotRobot: props.captchaEnabled ? false : true
        }

        this.captchaCallback = this.captchaCallback.bind(this);
        this.captchaExpiredCallback = this.captchaExpiredCallback.bind(this);
    }

    captchaCallback(response) {
        this.props.setCaptchaResponse(response);
        this.setState({
            iamNotRobot: true
        });
    };

    captchaExpiredCallback() {
        this.setState({
            iamNotRobot: false
        });
    }

    render() {
        const { sendingConfirmation, loginError, onSubmit, captchaEnabled, goToLogin } = this.props;

        let captchaComponent = null;
        if (captchaEnabled) {
            captchaComponent = <Reaptcha
                ref={e => this.recaptchaInstance = e}
                sitekey={process.env.REACT_APP_CAPTCHA_SITEKEY}
                onLoad={() => { }}
                onVerify={this.captchaCallback}
                onExpire={this.captchaExpiredCallback}
            />
        }


        return (
            <Grid verticalAlign="middle" >
                <LoadingComponent active={sendingConfirmation} message="Resending Confirmation" />
                <Grid.Column width={2} />
                <Grid.Column width={12}>
                    <Form noValidate
                        className="loginform"
                        error
                        onValidSubmit={onSubmit}
                        id="loginform"
                    >
                        <Image src={logo} size='medium' centered />
                        <div className="ui grid pad_lr_0">
                            <div className="two column row" style={{ padding: "0px" }}>
                                <div className="left floated column">
                                    <a className="item middle aligned cursor-pointer" onClick={goToLogin} style={{ paddingTop: "7px", display: 'inline-block' }} id="loginBtn">
                                        <Icon name='angle left' />&nbsp;Back to Login
                                        </a>
                                </div>
                            </div>
                        </div>
                        <Segment textAlign='center' basic style={{ backgroundColor: "#fff6f6", borderColor: "#e0b4b3" }}>
                            <Header as='h4' icon textAlign='center'>
                                <Icon name='mail' circular />
                                <Header.Content>Email Verification is Pending!</Header.Content>
                            </Header>
                            <p style={styles.mainText}>The verification mail has been sent to address<br />{loginError.data.email}</p>
                            <Divider />
                            <p style={styles.bottomMessageBold}>Haven’t receieved anything yet?</p>
                            <p style={styles.bottomMessage}>Get another confirmation email.</p>
                            <Grid>
                                <Grid.Row style={{ padding: "0px" }}>
                                    <Grid.Column>
                                        <div style={styles.captchaContainer}>
                                            {captchaComponent}
                                        </div>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row style={{ padding: "0px", marginTop: "5px" }}>
                                    <Grid.Column>
                                        <Button disabled={!this.state.iamNotRobot}
                                            className="button-submit" type="submit" id="submit">Resend Confirmation Mail
                                        </Button>
                                    </Grid.Column>
                                </Grid.Row>

                            </Grid>
                        </Segment>
                    </Form>
                </Grid.Column>
            </Grid>
        );
    }
}

export default ResendEmailComponent;